module.exports = __webpack_public_path__ + "static/media/Screenshot_1-thumb.395b1363.png";